module.exports = __webpack_public_path__ + "img/up.961ad141.svg";